'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _auth = require('selectors/auth');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Link = require('react-router/lib/Link');

var _Link2 = _interopRequireDefault(_Link);

var _components = require('components');

var _containers = require('containers');

var _auth2 = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth2);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./HomeHeader.scss');
var logoDarkImg = require('./logo-dark.png');
var logoLightImg = require('./logo-light.png');

var showFixedOnScrollY = 300;

var HomeHeader = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggingOut: state.auth.loggingOut,
    playlistKey: (0, _get7.default)(state, 'playlist.playlistActionData.key'),
    user: (0, _auth.getUser)(state)
  };
}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(HomeHeader, _Component);

  function HomeHeader() {
    var _ref;

    (0, _classCallCheck3.default)(this, HomeHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = HomeHeader.__proto__ || (0, _getPrototypeOf2.default)(HomeHeader)).call.apply(_ref, [this].concat(args)));

    _this.onScroll = function () {
      var top = window.scrollY;
      var isFixed = _this.state.fixHeader;
      var isHiddenFixed = _this.state.hiddenFixed;

      _this.setState({
        fixHeader: top > showFixedOnScrollY,
        hiddenFixed: (isHiddenFixed || isFixed) && top > showFixedOnScrollY / 2 && top <= showFixedOnScrollY
      });
    };

    _this.state = { fixHeader: false, hiddenFixed: false };
    return _this;
  }

  (0, _createClass3.default)(HomeHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _get5.default)(HomeHeader.prototype.__proto__ || (0, _getPrototypeOf2.default)(HomeHeader.prototype), 'componentDidMount', this).call(this, function () {
        _this2.onScroll();
        window.addEventListener('scroll', _this2.onScroll, false);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      (0, _get5.default)(HomeHeader.prototype.__proto__ || (0, _getPrototypeOf2.default)(HomeHeader.prototype), 'componentWillUnmount', this).call(this, function () {
        return window.removeEventListener('scroll', _this3.onScroll);
      });
    }
  }, {
    key: 'openLoginDialog',
    value: function openLoginDialog() {
      this.loginDialogEl.getWrappedInstance().getWrappedInstance().open();
    }
  }, {
    key: 'openForgotPasswordForm',
    value: function openForgotPasswordForm() {
      this.forgotPasswordDialogEl.getWrappedInstance().getWrappedInstance().open();
    }
  }, {
    key: 'openContactForm',
    value: function openContactForm() {
      this.loginContactEl.getWrappedInstance().open();
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.props.logout();
    }
  }, {
    key: 'renderNavigation',
    value: function renderNavigation() {
      var _props = this.props,
          user = _props.user,
          t = _props.t,
          playlistKey = _props.playlistKey,
          loggingOut = _props.loggingOut;


      if (loggingOut) {
        return _react2.default.createElement(_components.Loader, null);
      }

      return user ? _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _Link2.default,
          { to: _config2.default.app.defaultUserRoute, className: styles.navItem },
          t('Cright App')
        ),
        _react2.default.createElement(
          'span',
          { className: styles.navItem, onClick: this.openContactForm },
          t('Contact Us')
        ),
        _react2.default.createElement(
          'span',
          { className: styles.navItem, onClick: this.logout },
          t('Logout')
        )
      ) : _react2.default.createElement(
        'span',
        null,
        playlistKey && _react2.default.createElement(
          _Link2.default,
          { to: '/playlists/fromkey/' + playlistKey, className: (0, _classnames2.default)('text', styles.navItem) },
          t('Playlist')
        ),
        _react2.default.createElement(
          'span',
          { className: styles.navItem, onClick: this.openContactForm },
          t('Contact Us')
        ),
        _react2.default.createElement(
          'span',
          { className: styles.navItem, onClick: this.openForgotPasswordForm },
          t('Forgot password')
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)(styles.navItem, styles.loginBtn, 'btn btn-stroke btn-accent'),
            onClick: this.openLoginDialog
          },
          t('Log in')
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this4 = this;

      var _props2 = this.props,
          passwordCode = _props2.passwordCode,
          passwordKey = _props2.passwordKey,
          action = _props2.action,
          isLanding = _props2.isLanding,
          inApp = _props2.inApp;
      var _state = this.state,
          fixHeader = _state.fixHeader,
          hiddenFixed = _state.hiddenFixed;

      var logoImg = logoDarkImg;
      if (isLanding && !fixHeader && !hiddenFixed) {
        logoImg = logoLightImg;
      }
      var rootClassName = (0, _classnames2.default)(styles.homeHeader, 'homeContent', (_classNames = {}, (0, _defineProperty3.default)(_classNames, styles.isLanding, isLanding), (0, _defineProperty3.default)(_classNames, styles.fixHeader, fixHeader), (0, _defineProperty3.default)(_classNames, styles.hiddenFixed, hiddenFixed), (0, _defineProperty3.default)(_classNames, styles.inApp, inApp), _classNames));

      return _react2.default.createElement(
        'div',
        { className: rootClassName },
        _react2.default.createElement(
          'div',
          { className: styles.logoContainer },
          _react2.default.createElement(
            _Link2.default,
            { to: '/' },
            _react2.default.createElement('img', { src: logoImg, alt: 'logo' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.nav },
          _react2.default.createElement(
            'span',
            { className: styles.navItems },
            this.renderNavigation()
          ),
          _react2.default.createElement(_components.LangSelector, { className: (0, _classnames2.default)('margin-left-10', fixHeader || hiddenFixed || inApp || !isLanding ? 'accent' : 'light') }),
          _react2.default.createElement(
            'span',
            { className: styles.menuButton, onClick: function onClick(e) {
                return _this4.menuPopoverEl.toggle(e);
              } },
            _react2.default.createElement('i', { className: 'icon-menu' })
          ),
          _react2.default.createElement(
            _components.PopoverMenu,
            { id: 'menuPopover', ref: function ref(el) {
                return _this4.menuPopoverEl = el;
              }, className: styles.popoverMenu },
            this.renderNavigation()
          )
        ),
        _react2.default.createElement(_containers.LoginContact, { ref: function ref(el) {
            return _this4.loginContactEl = el;
          } }),
        _react2.default.createElement(_containers.ForgotPasswordDialog, { ref: function ref(el) {
            return _this4.forgotPasswordDialogEl = el;
          }, passwordKey: passwordKey, passwordCode: passwordCode, step: action }),
        _react2.default.createElement(_containers.LoginDialog, { ref: function ref(el) {
            return _this4.loginDialogEl = el;
          } })
      );
    }
  }]);
  return HomeHeader;
}(_ClientSideComponent2.default), _class3.propTypes = {
  action: _propTypes2.default.string,
  inApp: _propTypes2.default.bool,
  isLanding: _propTypes2.default.bool,
  loggingOut: _propTypes2.default.bool,
  logout: _propTypes2.default.func,
  passwordCode: _propTypes2.default.string,
  passwordKey: _propTypes2.default.string,
  playlistKey: _propTypes2.default.string,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openLoginDialog', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openLoginDialog'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openForgotPasswordForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openForgotPasswordForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openContactForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'openContactForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'logout', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'logout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderNavigation', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'renderNavigation'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = HomeHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HomeHeader.js
// module id = 2019
// module chunks = 1